import React from 'react';

interface TableInfoBarProps {
  currentPage: number;
  pageSize: number;
  totalRecords?: number;
  totalPages: number;
  label?: string;
  recordsOnPage?: number;
}

const TableInfoBar: React.FC<TableInfoBarProps> = ({
  currentPage,
  pageSize,
  totalRecords,
  totalPages,
  label = 'results',
  recordsOnPage,
}) => {
  if (totalPages <= 0 && !recordsOnPage) return null;

  const hasTotal = typeof totalRecords === 'number' && totalRecords > 0;
  const start = hasTotal ? (currentPage - 1) * pageSize + 1 : 0;
  const end = hasTotal ? Math.min(currentPage * pageSize, totalRecords!) : 0;
  const pages = Math.max(totalPages, 1);

  return (
    <div className="flex items-center gap-4 text-xs text-gray-500 px-1 py-1">
      {hasTotal ? (
        <span>
          Showing {start}–{end} of {totalRecords} {label}
        </span>
      ) : typeof recordsOnPage === 'number' ? (
        <span>
          Showing {recordsOnPage} {label}
        </span>
      ) : null}
      <span>Page {currentPage} of {pages}</span>
    </div>
  );
};

export default TableInfoBar;
